// Script for Section Menu, CatMenu , TabPostGridMenu
var categoryMenuDiv = document.querySelectorAll(".customSlider_swipe");
var categoryMenuItemsDiv = document.querySelectorAll(
  ".customSlider_swipe_items"
);
var categoryMenuItemDiv = document.querySelectorAll(".customSlider_swipe_item");
var categoryMenu =
  document.querySelector(".customSlider_swipe") !== null
    ? document.querySelector(".customSlider_swipe").offsetWidth
    : null;
var categoryMenu_item = document.querySelector(".categoryMenu_item");
var overlayTest = document.querySelector(".overlay");
var categoryMenuItems =
  document.querySelector(".customSlider_swipe_items") !== null
    ? document.querySelector(".customSlider_swipe_items").offsetWidth
    : null;
// Part for hover after we add overlay
categoryMenuItemDiv.forEach((element, index) => {
  var itemMouseMove = [];
  var mouseUp = element;
  element.children[1].addEventListener(
    "mousedown",
    function (e) {
      itemMouseMove[0] = e.clientX;
    },
    false
  );
  element.children[1].addEventListener("click", (e) => {
    if (itemMouseMove[0] === e.clientX) {
      window.location = mouseUp.children[0].href;
    }
    if (mouseUp.closest(".search-results") && itemMouseMove[0] === e.clientX) {
      categoryMenuItemDiv.forEach((x) => {
        if (x.classList.contains("active")) {
          x.classList.remove("active");
        } else {
          x.classList.remove("active");
        }
      });
      element.classList.add("active");
    }
  });
  element.children[1].addEventListener(
    "mousemove",
    function (e) {
      if (mouseUp.closest(".search-results")) {
        element.children[0].style.color = `#021d38`;
      } else if (
        mouseUp
          .closest(".customSlider_swipe")
          .classList.contains("tabbet_wrapper")
      ) {
        element.children[0].style.color = `#021d38`;
      } else {
        element.children[0].style.color = `#000000`;
      }
      element.children[0].style.transition = "all .2s";

      if (!element.classList.contains("active")) {
        element.classList.add("active");
      }
    },
    false
  );
  element.children[1].addEventListener(
    "mouseout",
    function (e) {
      element.children[0].style.color = `#021d38`;
      element.children[0].style.transition = "all .2s";
      if (mouseUp.closest(".search-results")) {
        element.children[0].style.color = `#000000`;
      }
      if (element.classList.contains("active")) {
        element.classList.remove("active");
      }
    },
    false
  );
});
// Part for hover after we add overlay
categoryMenuDiv.forEach((element) => {
  var testimatesss = [];
  var moving = false;
  var startPoint = 0;
  let movies = [];
  var mousemove = 0;
  movies[0] = 0;
  element.children[0].addEventListener("mousedown", (e) => {
    testimatesss[0] = e.clientX;
    if (element.offsetWidth <= element.children[0].offsetWidth) {
      moving = true;
    }
  });
  element.children[0].addEventListener("mousemove", (e) => {
    if (moving) {
      startPoint = e.clientX - testimatesss[0];
      mousemove = movies[0] + startPoint;
      element.children[0].style.transition = `all 0s `;
      if (mousemove < -element.children[0].offsetWidth + element.offsetWidth) {
        element.children[0].style.transform = `translateX(${
          -element.children[0].offsetWidth + element.offsetWidth
        }px) `;
        mousemove = -element.children[0].offsetWidth + element.offsetWidth;
      } else if (0 <= mousemove) {
        element.children[0].style.transform = `translateX(0px) `;
        mousemove = 0;
      } else {
        element.children[0].style.transform = `translateX(${mousemove}px) `;
      }
    } else {
      moving = false;
    }
  });
  document.children[0].addEventListener("mouseup", (e) => {
    movies = [];
    movies[0] = mousemove;
    moving = false;
  });

  element.children[0].addEventListener(
    "touchstart",
    (e) => {
      testimatesss[0] = e.touches[0].clientX;
      if (element.offsetWidth <= element.children[0].offsetWidth) {
        moving = true;
      }
    },
    { passive: true }
  );

  element.children[0].addEventListener(
    "touchmove",
    (e) => {
      if (moving) {
        startPoint = e.touches[0].clientX - testimatesss[0];
        mousemove = movies[0] + startPoint;
        element.children[0].style.transition = `all 0s `;
        if (
          mousemove <
          -element.children[0].offsetWidth + element.offsetWidth
        ) {
          element.children[0].style.transform = `translateX(${
            -element.children[0].offsetWidth + element.offsetWidth
          }px) `;
          mousemove = -element.children[0].offsetWidth + element.offsetWidth;
        } else if (0 <= mousemove) {
          element.children[0].style.transform = `translateX(0px) `;
          mousemove = 0;
        } else {
          element.children[0].style.transform = `translateX(${mousemove}px) `;
        }
      } else {
        moving = false;
      }
    },
    { passive: false }
  );

  document.children[0].addEventListener("touchend", (e) => {
    movies = [];
    movies[0] = mousemove;
    moving = false;
  });

  var redirect = false;
  element.querySelectorAll(".customSlider_swipe_item").forEach((e) => {
    var elementDrag = false;
    var itemMouseMove = [];
    var mouseUp = e;
    e.children[1].addEventListener(
      "mousedown",
      function (e) {
        itemMouseMove[0] = e.clientX;
      },
      false
    );
    e.children[1].addEventListener("mousemove", function (e) {
      if (
        e.clientX - itemMouseMove[0] <= 2 ||
        e.clientX - itemMouseMove[0] >= -2
      ) {
        elementDrag = true;
      }
    });

    e.addEventListener(
      "mouseup",
      function (e) {
        if (
          mousemove <= element.offsetWidth - element.children[0].offsetWidth ||
          mousemove >= 0
        ) {
          redirect = true;
        } else {
          redirect = false;
        }
      },
      { passive: true }
    );

    e.children[1].addEventListener(
      "mouseup",
      function (e) {
        itemMouseMove = [];
        elementDrag = false;
      },
      false
    );
  });

  if (element.classList.contains("slider_arrows")) {
    element.children[2].style.display = "none";
    element.children[2].style.transition = `all 0.3s `;
    if (element.offsetWidth <= element.children[0].offsetWidth) {
      element.children[0].style.transform = `translateX(0px) `;
      element.children[1].style.display = "block";
    }
    if (element.offsetWidth >= element.children[0].offsetWidth) {
      element.children[1].style.display = "none";
      element.children[2].style.display = "none";
    }

    element.children[0].addEventListener("mousemove", (e) => {
      if (element.offsetWidth >= element.children[0].offsetWidth) {
        element.children[0].style.transform = `translateX(0px) `;
      } else {
        if (
          mousemove <=
          -element.children[0].offsetWidth + element.offsetWidth
        ) {
          element.children[1].style.display = "none";
          element.children[1].style.transition = `all 0.3s `;
          element.children[2].style.display = "block";
          element.children[2].style.transition = `all 0.3s `;
        } else if (mousemove >= 0) {
          element.children[1].style.display = "block";
          element.children[1].style.transition = `all 0.3s `;
          element.children[2].style.display = "none";
          element.children[2].style.transition = `all 0.3s `;
          element.children[0].style.transform = `translateX(0px) `;
        } else {
          element.children[1].style.display = "block";
          element.children[1].style.transition = `all 0.3s `;
          element.children[2].style.display = "block";
          element.children[2].style.transition = `all 0.3s `;
        }
      }
    });
    element.children[0].addEventListener(
      "touchmove",
      (e) => {
        if (element.offsetWidth >= element.children[0].offsetWidth) {
          element.children[0].style.transform = `translateX(0px) `;
        } else {
          if (
            mousemove <=
            -element.children[0].offsetWidth + element.offsetWidth
          ) {
            element.children[1].style.display = "none";
            element.children[1].style.transition = `all 0.3s `;
            element.children[2].style.display = "block";
            element.children[2].style.transition = `all 0.3s `;
          } else if (mousemove >= 0) {
            element.children[1].style.display = "block";
            element.children[1].style.transition = `all 0.3s `;
            element.children[2].style.display = "none";
            element.children[2].style.transition = `all 0.3s `;
            element.children[0].style.transform = `translateX(0px) `;
          } else {
            element.children[1].style.display = "block";
            element.children[1].style.transition = `all 0.3s `;
            element.children[2].style.display = "block";
            element.children[2].style.transition = `all 0.3s `;
          }
        }
      },
      { passive: true }
    );

    let step;
    if (element.classList.contains("categoryMenu_redesign")) {
      if (window.innerWidth > 992 && window.innerWidth < 1025) {
        step = 130;
      }
      if (window.innerWidth > 1024 && window.innerWidth < 1200) {
        step = 123;
      }
      if (window.innerWidth > 1199) {
        step = 115;
      }
    } else {
      step = 150;
    }

    element.children[1].addEventListener("click", () => {
      // if(!element.classList.contains('clicked') ){
      // element.children[1].classList.add('clicked')
      // }
      if (mousemove < -element.children[0].offsetWidth + element.offsetWidth) {
        mousemove = -element.children[0].offsetWidth + element.offsetWidth;
      } else {
        if (
          -element.children[0].offsetWidth + element.offsetWidth - mousemove >=
          -step
        ) {
          element.children[1].style.display = "none";
          element.children[1].style.transition = `all 0.3s `;
          mousemove = -element.children[0].offsetWidth + element.offsetWidth;
        } else {
          mousemove = movies[0] - step;
          element.children[2].style.display = "block";
          element.children[2].style.transition = `all 0.3s `;
          element.children[1].style.display = "block";
          element.children[1].style.transition = `all 0.3s `;
        }
      }
      element.children[0].style.transform = `translateX(${mousemove}px) `;
      element.children[0].style.transition = `all 0.5s `;
      movies[0] = mousemove;
    });

    element.children[1].addEventListener("mousedown", (e) => {
      element.children[1].classList.add("clicked");
    });
    element.children[1].addEventListener("mouseup", () => {
      element.children[1].classList.remove("clicked");
    });

    element.children[2].addEventListener("click", (e) => {
      if (mousemove < 0 && mousemove <= -step) {
        mousemove = movies[0] + step;
        element.children[1].style.display = "block";
        element.children[1].style.transition = `all 0.3s `;
      } else {
        mousemove = 0;
        element.children[2].style.display = "none";
        element.children[2].style.transition = `all 0.3s `;
      }
      element.children[0].style.transform = `translateX(${mousemove}px) `;
      element.children[0].style.transition = `all 0.5s `;
      movies[0] = mousemove;
    });
    element.children[2].addEventListener("mousedown", (e) => {
      element.children[2].classList.add("clicked");
    });
    element.children[2].addEventListener("mouseup", () => {
      element.children[2].classList.remove("clicked");
    });
  }
});

var searchPage = document.querySelectorAll(".search_page");
if (searchPage.length > 0) {
  let items = document.querySelectorAll(".categoryMenu_item ");
  items.forEach((item, i) => {
    item.addEventListener("click", function (e) {
      var navScroll =
        document.body.scrollTop || document.documentElement.scrollTop;
      var hrefAttrOfItem = items[i].children[0].getAttribute("point");
      var section = document.getElementById(hrefAttrOfItem.split("#")[1]);
      var sectionPostion = section.getBoundingClientRect().top + window.scrollY;
      scroll({
        top: sectionPostion - 130,
        behavior: "smooth",
      });
    });
  });
}
